// extracted by mini-css-extract-plugin
export default {"header":"PartsDetails_header__f1Xbi","table":"PartsDetails_table__4M3Ma"};